module.exports = __webpack_public_path__ + "media/images/userAccess-icon-f407f4124dc8dedfa4e2049893ff802d.svg";